<template>
  <span class="status-pill" :class="`status-pill--${state}`">
    <span class="status-pill__dot"></span>
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { i18n } from "../../../i18n";
import type { PillState } from "../subscriptionLogic";

const props = defineProps<{ state: PillState }>();
const t = (key: string, named: Record<string, unknown> = {}): string => i18n.global.t(key, named);

const label = computed(() => {
  switch (props.state) {
    case "cancelled":
      return t("purchases.status_pill.cancelled");
    case "paused":
      return t("purchases.status_pill.paused");
    case "payment_failed":
      return t("purchases.status_pill.payment_failed");
    default:
      return t("purchases.status_pill.active");
  }
});
</script>

<style scoped lang="scss">
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 700;
  color: #000;
  white-space: nowrap;

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.35);
  }

  &--active {
    background-color: #4caf50;
  }

  &--cancelled {
    background-color: #e53935;
  }

  &--paused {
    background-color: #fb8c00;
  }

  // Urgent like cancelled, but distinguishable from it — this one is fixable.
  &--payment_failed {
    background-color: #c62828;
  }
}
</style>
